/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CoordinatesInputs */

const en_coordinates = /** @type {(inputs: CoordinatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coordinates`)
};

const de_coordinates = /** @type {(inputs: CoordinatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koordinaten`)
};

/**
* | output |
* | --- |
* | "Coordinates" |
*
* @param {CoordinatesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coordinates = /** @type {((inputs?: CoordinatesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CoordinatesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coordinates(inputs)
	return de_coordinates(inputs)
});